import {
  dataLabelsCompact,
  dataLabelsDecimals,
  dataLabelsFlipHorizontally,
  dataLabelsHideThreshold,
  dataLabelsSizes,
  granularity,
  legendPosition,
  palette,
  showDataLabels,
} from "@/settings/charts/settingsDictionary";
import { FAMILY } from "@/settings/widgetFamilies";
import { Config } from "@/types/charts";

const stackedColumnLineTimeSettings = {
  palette,
  xAxis: {
    default: "month",
    type: "select",
    label: "Horizontal Axis (Date)",
    dictionary: "timeMetrics",
    apiParameter: "dimension",
    gridPosition: [0, 0],
    tooltipOrder: 0,
  },
  displayMetrics: {
    default: ["leads", "acquisitions"],
    type: "select",
    label: "Display Metrics (Stacked Bars)",
    dictionary: "displayMetrics",
    multiple: true,
    searchable: true,
    gridPosition: [1, 0],
    tooltipOrder: 1,
  },
  lineMetric: {
    default: "spend",
    type: "select",
    label: "Display Metric (Line)",
    dictionary: "displayMetrics",
    gridPosition: [2, 0],
    tooltipOrder: 2,
  },
  legendPosition: { ...legendPosition, gridPosition: [3, 0] },
  xAxisName: {
    default: "",
    type: "text",
    label: "Horizontal Axis Title",
    gridPosition: [0, 1],
    forAxis: "xAxis",
  },
  yAxisName: {
    default: "",
    type: "text",
    label: "Vertical Axis Title",
    gridPosition: [1, 1],
  },
};

const stackedColumnLineTimePlanSettings = {
  ...stackedColumnLineTimeSettings,
  displayMetrics: { ...stackedColumnLineTimeSettings.displayMetrics, default: ["impressions"] },
  lineMetric: { ...stackedColumnLineTimeSettings.lineMetric, default: "channel_budget" },
  showDataLabels: { ...showDataLabels, gridPosition: [4, 0] },
  dataLabelsSizes: { ...dataLabelsSizes, gridPosition: [4, 1] },
  dataLabelsCompact: { ...dataLabelsCompact, gridPosition: [5, 0] },
  dataLabelsDecimals: { ...dataLabelsDecimals, gridPosition: [5, 1] },
  dataLabelsHideThreshold: { ...dataLabelsHideThreshold, gridPosition: [6, 1] },
  dataLabelsFlipHorizontally: { ...dataLabelsFlipHorizontally, gridPosition: [6, 0] },
};

const stackedColumnLineTimePlanExploreSettings = {
  ...stackedColumnLineTimeSettings,
  showDataLabels: { ...showDataLabels, gridPosition: [4, 0] },
  dataLabelsSizes: { ...dataLabelsSizes, gridPosition: [4, 1] },
  dataLabelsCompact: { ...dataLabelsCompact, gridPosition: [5, 0] },
  dataLabelsDecimals: { ...dataLabelsDecimals, gridPosition: [5, 1] },
  dataLabelsHideThreshold: { ...dataLabelsHideThreshold, gridPosition: [6, 1] },
  dataLabelsFlipHorizontally: { ...dataLabelsFlipHorizontally, gridPosition: [6, 0] },
};

const stackedColumnLineTimeDualSettings = {
  palette,
  displayMetricsSource: { default: "explore", dictionary: "metricSources" },
  lineMetricSource: { default: "plan", dictionary: "metricSources" },
  xAxis: {
    default: "month",
    type: "select",
    label: "Horizontal Axis (Date)",
    dictionary: "timeMetrics",
    apiParameter: "dimension",
    gridPosition: [0, 0],
    tooltipOrder: 0,
  },
  displayMetrics: {
    default: ["impressions"],
    type: "select",
    label: "Display Metrics (Stacked Bars)",
    dictionary: "displayMetrics",
    multiple: true,
    searchable: true,
    sourceFrom: "displayMetricsSource",
    gridPosition: [1, 0],
    tooltipOrder: 1,
  },
  lineMetric: {
    default: "channel_budget",
    defaultBySource: { plan: "channel_budget", explore: "spend" },
    type: "select",
    label: "Display Metric (Line)",
    dictionary: "displayMetrics",
    sourceFrom: "lineMetricSource",
    gridPosition: [2, 0],
    tooltipOrder: 2,
  },
  legendPosition: { ...legendPosition, gridPosition: [3, 0] },
  xAxisName: {
    default: "",
    type: "text",
    label: "Horizontal Axis Title",
    gridPosition: [0, 1],
    forAxis: "xAxis",
  },
  yAxisName: {
    default: "",
    type: "text",
    label: "Vertical Axis Title",
    gridPosition: [1, 1],
  },
  showDataLabels: { ...showDataLabels, gridPosition: [4, 0] },
  dataLabelsSizes: { ...dataLabelsSizes, gridPosition: [4, 1] },
  dataLabelsCompact: { ...dataLabelsCompact, gridPosition: [5, 0] },
  dataLabelsDecimals: { ...dataLabelsDecimals, gridPosition: [5, 1] },
  dataLabelsHideThreshold: { ...dataLabelsHideThreshold, gridPosition: [6, 1] },
  dataLabelsFlipHorizontally: { ...dataLabelsFlipHorizontally, gridPosition: [6, 0] },
};

export default <Config>{
  family: [FAMILY.OVERTIME],
  name: "stackedColumnLineTimeChart",
  title: "Stacked Column & Line Type 2",
  defaultHeight: 6,
  controls: [granularity],
  dataModes: ["project", "explore", "dual"],
  settings: stackedColumnLineTimeSettings,
  planSettings: stackedColumnLineTimePlanSettings,
  planExploreSettings: stackedColumnLineTimePlanExploreSettings,
  planDualSettings: stackedColumnLineTimeDualSettings,
};
